import { FormikErrors, FormikTouched, getIn } from 'formik';

import { OnboardingLoginFormValues } from './OnboardingForms/onboardingFormTypes';

/**
 * This function is used to get the error text to display
 * @param errorsState formik errors state
 * @param tochedState formik errors state
 * @returns
 */
export function getFormErrorText<T = OnboardingLoginFormValues>(
  errorsState: FormikErrors<T>,
  touchedState: FormikTouched<T>,
) {
  const errorFieldKeys = Object.keys(errorsState);
  if (!errorFieldKeys.length) return '';

  return errorFieldKeys
    .reduce<string[]>((errorMessages, key) => {
      if (getIn(touchedState, key) && getIn(errorsState, key)) {
        const message: string = getIn(errorsState, key);
        errorMessages.push(message.replace('.', ''));
      }
      return errorMessages;
    }, [])
    .join(', ');
}
